function normalizePath(path) {
    const normalized = path.replace(/\/$/, '');
    return normalized || '/';
}

function getAdminBarOffset() {
    const adminBar = document.getElementById('wpadminbar');

    if (!adminBar) return 0;

    const position = window.getComputedStyle(adminBar).position;

    if (position === 'fixed' || position === 'sticky') {
        return adminBar.offsetHeight;
    }

    return 0;
}

function getHeaderOffset() {
    const header = document.querySelector('[data-header]');
    const bar = header?.querySelector('.site-header__inner') || header;
    const headerHeight = bar ? bar.getBoundingClientRect().height : 0;

    // Slightly less than the bar height — section sits closer under the header.
    return Math.max(0, Math.ceil(headerHeight + getAdminBarOffset() - 16));
}

function cleanUrl() {
    return `${window.location.pathname}${window.location.search}`;
}

function scrollToSection(sectionId, behavior = 'smooth') {
    const target = document.getElementById(sectionId);
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    window.scrollTo({ top: Math.max(0, top), behavior });

    return true;
}

function removeHashFromUrl() {
    if (!window.location.hash) return;
    history.replaceState(null, '', cleanUrl());
}

function runAfterLayout(callback) {
    requestAnimationFrame(() => {
        requestAnimationFrame(callback);
    });
}

function handleLoadedHash() {
    const sectionId = window.location.hash.slice(1);
    if (!sectionId || !document.getElementById(sectionId)) return;

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    let hashRemoved = false;

    const applyScroll = (shouldRemoveHash = false) => {
        if (!scrollToSection(sectionId, 'auto')) return;

        if (shouldRemoveHash && !hashRemoved) {
            hashRemoved = true;
            removeHashFromUrl();
        }
    };

    const scheduleCorrections = () => {
        runAfterLayout(() => applyScroll(false));
    };

    scheduleCorrections();

    if (document.readyState === 'complete') {
        scheduleCorrections();
    } else {
        window.addEventListener('load', scheduleCorrections, { once: true });
    }

    [120, 280, 520, 900].forEach((delay, index, delays) => {
        window.setTimeout(() => {
            applyScroll(index === delays.length - 1);
        }, delay);
    });
}

function handleAnchorClick(event) {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;

    let url;

    try {
        url = new URL(link.href, window.location.origin);
    } catch {
        return;
    }

    if (url.origin !== window.location.origin) return;

    const sectionId = url.hash.slice(1);
    if (!sectionId) return;

    if (normalizePath(url.pathname) !== normalizePath(window.location.pathname)) {
        return;
    }

    if (!document.getElementById(sectionId)) return;

    event.preventDefault();

    if (!scrollToSection(sectionId, 'smooth')) return;

    window.setTimeout(removeHashFromUrl, 500);
}

export function initAnchors() {
    handleLoadedHash();
    document.addEventListener('click', handleAnchorClick);
}
